<template>
  <v-select
    class="tema-eixo-combo"
    id="temas-select"
    v-model="filter.statusId"
    item-text="statusNome"
    item-name="statusNome"
    item-value="statusId"
    :items="statusRelacionamento"
    label="Status"
    hide-details="auto"
    :solo="solo"
    :disabled="disabled"
    placeholder="Status"
    v-on:change="onChangeStatus"
    :clearable="true"
    :multiple="isMultiple ? true : false"
    :return-object="isMultiple ? true : false"
  >
    <template v-slot:selection="{ item, index }">
      <v-chip v-bind="item" small v-if="index < maxDisplay">
        <span>{{ item.statusNome }}</span>
      </v-chip>
      <span v-if="index === maxDisplay" class="grey--text caption"
        >(+{{ filter.statusId.length - maxDisplay }} status)</span
      >
    </template>
    <template slot="no-data">
      Nenhum Status de Relacionamento retornado
    </template>
  </v-select>
</template>

<script>
import { StatusRelacionamentoApi } from "../API/StatusRelacionamentoApi.js";

export default {
  name: "AppStatusCombobox",
  props: [
    "filter",
    "isMultiple",
    "disabled",
    "solo",
    "includeElegivelIan",
    {
      solo: {
        type: Boolean,
        default: true,
      },
    },
  ],
  mounted() {
    this.loadStatus();
  },
  methods: {
    loadStatus() {
      StatusRelacionamentoApi.list()
        .then((resp) => {
          const statusRelacionamento = resp.data || [];

          if (
            this.includeElegivelIan &&
            !statusRelacionamento.some((status) =>
              this.isElegivelIanStatus(status)
            )
          ) {
            statusRelacionamento.push({
              statusId: "elegivelIan",
              statusNome: "Elegível IAN",
            });
          }

          this.statusRelacionamento = statusRelacionamento;
        })
        .catch();
    },
    onChangeStatus(value) {
      const selectedStatus = this.isMultiple
        ? value
        : this.statusRelacionamento.find((status) => status.statusId === value);

      this.$emit("onChange", value, selectedStatus || null);
    },
    isElegivelIanStatus(status) {
      const statusName = status && status.statusNome;

      return (
        statusName &&
        statusName
          .toString()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase() === "elegivel ian"
      );
    },
  },
  data() {
    return {
      statusRelacionamento: [],
      maxDisplay: 1,
    };
  },
};
</script>
